// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { DeviceAccessToken, IDeviceAccessToken } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getForDevice(deviceId?: string): ApiResult<DeviceAccessToken[]> {
	return get<IDeviceAccessToken[]>(`/api/deviceaccesstoken/for-device/${ deviceId }`).then(result => result === undefined ? undefined : result.map(o => new DeviceAccessToken(o)));
}

export async function issue(deviceId?: string, label?: string, expiresAt?: Date): ApiResult<DeviceAccessToken> {
		const queryParams = [label !== undefined ? `label=${label}` : undefined,
			expiresAt !== undefined ? `expiresAt=${expiresAt.toISOString()}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return post<IDeviceAccessToken>(`/api/deviceaccesstoken/for-device/${ deviceId }${query}`).then(result => result === undefined ? undefined :  new DeviceAccessToken(result));
}

export async function revoke(id?: string): ApiResult<undefined> {
	return del(`/api/deviceaccesstoken/${ id }`);
}
